import React from "react";
import TrikeIcon from "../../../Common/Svgs/TrikeIcon";
import TrackerMobileIcon from "../../../Common/Svgs/TrackerMobileIcon";

const TrackerTags = ({ hasMobileData, hasTrikeData }) => {
  // Both mobile and trike data are available
  if (hasMobileData && hasTrikeData) {
    return (
      <div
        className="px-2 py-1 rounded flex items-center gap-x-2"
        style={{
          background: "#F5F3FF",
        }}
      >
        <TrikeIcon size={16} className="text-[#775DFA]" />

        <p className="font-poppins text-xs font-medium text-[#775DFA]">+</p>

        <TrackerMobileIcon size={16} className="text-[#775DFA]" />
      </div>
    );
  }

  // Only mobile data is available
  if (hasMobileData) {
    return (
      <div className="px-2 py-1 bg-yellow-10 rounded">
        <TrackerMobileIcon size={16} className="text-yellow-dark" />
      </div>
    );
  }

  // Only trike data is available
  if (hasTrikeData) {
    return (
      <div className="px-2 py-1 bg-green-10 rounded">
        <TrikeIcon size={16} className="text-green" />
      </div>
    );
  }

  return null;
};

export default TrackerTags;
